import Dashboard from "@/components/Dashboard";
import WithNavbar from "../navs/components/withNavbar";

export const DashboardPage = () => {
  return (
    <div className="bg-white">
      <WithNavbar />
      <Dashboard />
    </div>
  );
};
